<template>
  <v-container fluid grid-list-md>
    <v-flex>
      <span class="headline">Please select a plan</span>
    </v-flex>
    <v-container>
      <v-row no-gutters>
        <v-col>
          <v-btn-toggle
            mandatory
            v-model="selectedCurrency"
            v-if="currencies && currencies.length > 1">
            <template v-for="c in currencies">
              <v-btn color="primary" text :key="c" :value="c">
                {{ c }}
              </v-btn>
            </template>
          </v-btn-toggle>
        </v-col>
        <v-col>
          <v-radio-group v-model="selectedInterval" row class="justify-end">
            <v-radio label="Monthly" value="month"></v-radio>
            <v-radio label="Yearly (2 months free)" value="year"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-data-iterator
      :items="filteredPlans"
      :items-per-page="3"
      hide-default-footer
    >
      <template v-slot:default="props">
        <v-layout wrap>
          <v-flex
            v-for="item in props.items"
            :key="item.id"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-card :elevation="hover ? 24 : 1" @click="selectPlan(item)">
                  <v-card-title>
                      <h4>{{ item.name }}</h4>
                      <v-spacer/>
                      <v-icon v-if="isSelectedPlan(item)" color="primary">check</v-icon>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="text-center">
                    <span class="primary--text title" v-if="item.interval==='month'">Billed monthly</span>
                    <span class="primary--text title" v-else>Billed annually</span>
                  </v-card-text>
                  <v-list dense>
                    <v-list-item v-for="m in Object.keys(item.metadata)" :key="m">
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-check-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content class="align-end">
                        {{ item.metadata[m] }}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-card-actions>
                    <v-flex class="text-center">
                      <v-btn color="primary" :disabled="isSelectedPlan(item)">
                        {{ item | formatPlanAmount }}
                      </v-btn>
                    </v-flex>
                  </v-card-actions>
                </v-card>
              </template>
            </v-hover>
          </v-flex>
        </v-layout>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  props: {
    currencies: {
      type: Array,
      default: () => []
    },
    plans: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    items: [],
    selectedInterval: 'month',
    selectedPlan: null,
    selectedCurrency: 'usd'
  }),
  watch: {
    selectedCurrency (value) {
      console.log('value', value)
      if (this.selectedPlan) {
        console.log('this.selectedPlan', this.selectedPlan)
        this.selectedPlan = this.plans.find(p => p.name === this.selectedPlan.name && p.currency === value && p.interval === this.selectedPlan.interval)
        this.$emit('select-plan-update', this.selectedPlan.id)
      }
    },
    selectedInterval (value) {
      if (this.selectedPlan) {
        if (value === 'year') {
          this.selectedPlan = this.plans.find(p => p.amount === this.selectedPlan.amount * 10 && p.currency === this.selectedCurrency)
        } else {
          this.selectedPlan = this.plans.find(p => p.amount === this.selectedPlan.amount / 10 && p.currency === this.selectedCurrency)
        }
        this.$emit('select-plan-update', this.selectedPlan.id)
      }
    }
  },
  computed: {
    filteredPlans () {
      return this.plans.filter(p => p.interval === this.selectedInterval && p.currency === this.selectedCurrency)
    }
  },
  methods: {
    isSelectedPlan (plan) {
      return this.selectedPlan && this.selectedPlan.id === plan.id
    },
    selectPlan (plan) {
      this.selectedPlan = plan
      this.$emit('select-plan-update', this.selectedPlan.id)
    }
  },
  filters: {
    formatPlanAmount (plan) {
      return `$${plan.amount / 100} / ${plan.interval}`
    }
  }
}
</script>

<style>

</style>
